import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { WeatherReportGrabber } from './WeatherReportSidebar';
import { WEATHER_REPORT_SCHEMA_URL, WEATHER_REPORT_COMPONENT_TYPE } from './WeatherReport.constants';

// Lazy load view components
const WeatherReportAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorWeatherReportAdd" */ './WeatherReportSidebar'), 'WeatherReportAdd');

const WeatherReportEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorWeatherReportEdit" */ './admin/WeatherReportEdit'), 'WeatherReportEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const WeatherReportConfig: AdminJsonComponentConfig = {
  schemaUrl: WEATHER_REPORT_SCHEMA_URL,
  componentType: WEATHER_REPORT_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: WeatherReportAdd,
    dragComponentView: WeatherReportGrabber,
    editComponentView: WeatherReportEdit,
    createComponentView: WeatherReportEdit,
  },
};
